import { localDateToIsoDate } from '@/lib/date'

export type AgendaRangeView = 'day' | 'week' | 'month'

export function rangeFor(
  date: Date,
  view: AgendaRangeView
): { from: string; to: string } {
  const from = new Date(date)
  const to = new Date(date)

  if (view === 'week') {
    const day = (from.getDay() + 6) % 7
    from.setDate(from.getDate() - day)
    to.setTime(from.getTime())
    to.setDate(from.getDate() + 6)
  } else if (view === 'month') {
    from.setDate(1)
    to.setMonth(to.getMonth() + 1, 0)
  }

  return { from: localDateToIsoDate(from), to: localDateToIsoDate(to) }
}
